(function () {
    'use strict';

    angular.module('app.idle', [
        'utils',
        'ui.bootstrap',
        'ngIdle'
    ]);
})();